import { reducer as loyaltiesReducer } from './loyalty.slice';

export default loyaltiesReducer;
